import { FocusTrapManager } from './FocusTrapManager';
import { FocusTrap } from './FocusTrap';
/**
 * Функция для создания ловушки фокуса
 */
export function createFocusTrap(scope, options) {
    if (options === void 0) { options = {}; }
    var manager = FocusTrapManager.getInstance();
    return new FocusTrap(manager, scope, options);
}
